import { TFunction } from 'i18next';
import { useTranslation } from 'react-i18next';
import { useRadiusFilter } from 'lib/hooks/useSrpFilters';
import { SrpRadiusFilterValue } from 'types/srpFilters';
import List from 'components/Shared/List';

interface RadiusModalDropdownProps {
  onListItemClick?: (value: string) => void;
  setIsModalOpen?: (isOpen: boolean) => void;
}

const radiusOptions: SrpRadiusFilterValue[] = ['Any', 10, 25, 50, 100, 200, 300, 500];

export default function RadiusModal({
  onListItemClick,
  setIsModalOpen,
}: RadiusModalDropdownProps): JSX.Element {
  const { t } = useTranslation();
  const { value, setValue } = useRadiusFilter();

  function onClick(radius: SrpRadiusFilterValue): void {
    const label = getRadiusLabel(t, radius);
    onListItemClick?.(label);
    setValue(radius);
    setIsModalOpen?.(false);
  }

  return (
    <List
      options={radiusOptions}
      className="radius-modal"
      onClick={onClick}
      labelExtractor={(option): string => getRadiusLabel(t, option)}
      valueExtractor={(option): string => option}
      isSelected={(option): boolean => option === value}
      ariaLabel="Radius options"
      dataTestId="radius-options-list"
    />
  );
}

export function getRadiusLabel(t: TFunction, value?: SrpRadiusFilterValue): string {
  if (value) {
    const valueString = value === 'Any' ? value : `${value.toString()} ${t('srp.miles')}`;
    return valueString;
  }
  return t('srp.locationFilter.selectRadius');
}
